/**
 * O CPF `candidate` já está cadastrado em alguma das vidas `registered`?
 *
 * Só acusa duplicidade quando os DOIS lados têm os 11 dígitos completos. Vidas
 * hidratadas do InsureMO voltam com o CPF MASCARADO por PII (ex.: `390****4705`,
 * às vezes mascarado por inteiro), e a comparação anterior tratava cada `*` como
 * "qualquer dígito": um CPF mascarado casava com quase todo CPF do mesmo
 * tamanho, e o modal de Adicionar vida acusava "CPF já cadastrado" para
 * qualquer CPF digitado.
 *
 * Duplicidade real não escapa: quem decide é o backend, que guarda os CPFs
 * COMPLETOS no índice da apólice (`GroupLifePolicyCpfIndex`) e recusa a
 * inclusão/edição com mensagem própria. Aqui é só o atalho de UI para o caso
 * que dá para afirmar localmente.
 */
export function isCpfAlreadyRegistered(
  candidate: string | undefined,
  registered: Array<string | undefined>
): boolean {
  const digits = (value?: string) => (value ?? '').replace(/\D/g, '');
  const candidateDigits = digits(candidate);
  if (candidateDigits.length !== 11) return false;
  return registered.some(value => digits(value) === candidateDigits);
}
